<template>
	<div>
		<v-btn color="primary" v-if="value" outlined small :block="block">{{
			$t("Paid")
		}}</v-btn>
		<v-btn color="error" v-else outlined small>{{
			$t("label.unpaid")
		}}</v-btn>
	</div>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			required: true,
		},
		block: {
			type: Boolean,
			default: false,
		},
	},
};
</script>